var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedFronWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "70px",
    viewBox: "0 0 80 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B44AA6FF-2C90-4DBA-8FE9-1AAE50255037") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BOOKING-3",
    transform: "translate(-49.000000, -762.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(10.000000, 762.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bed-front-light",
    transform: "translate(39.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,10 L10,16.34375 C11.46875,15.5 13.171875,15 15,15 L32.5,15 C35.484375,15 38.171875,16.3125 40,18.390625 C41.828125,16.3125 44.515625,15 47.5,15 L65,15 C66.828125,15 68.53125,15.484375 70,16.34375 L70,10 C70,7.234375 67.765625,5 65,5 L15,5 C12.234375,5 10,7.234375 10,10 Z M75,25 L75,32.5 C78.03125,34.78125 80,38.40625 80,42.5 L80,57.5 L80,67.5 C80,68.875 78.875,70 77.5,70 C76.125,70 75,68.875 75,67.5 L75,60 L5,60 L5,67.5 C5,68.875 3.875,70 2.5,70 C1.125,70 0,68.875 0,67.5 L0,57.5 L0,42.5 C0,38.40625 1.96875,34.78125 5,32.5 L5,25 L5,10 C5,4.484375 9.484375,0 15,0 L65,0 C70.515625,0 75,4.484375 75,10 L75,25 Z M70,30.25 L70,25 C70,22.234375 67.765625,20 65,20 L47.5,20 C44.734375,20 42.5,22.234375 42.5,25 L42.5,30 L67.5,30 C68.359375,30 69.1875,30.09375 70,30.25 Z M37.5,30 L37.5,25 C37.5,22.234375 35.265625,20 32.5,20 L15,20 C12.234375,20 10,22.234375 10,25 L10,30.25 C10.8125,30.09375 11.640625,30 12.5,30 L37.5,30 Z M75,42.5 C75,38.359375 71.640625,35 67.5,35 L12.5,35 C8.359375,35 5,38.359375 5,42.5 L5,55 L75,55 L75,42.5 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedFronWhite);
export default __webpack_public_path__ + "static/media/bed-fron-white.64f3a7818ddcd87f7fe4f5eb2d0049f6.svg";
export { ForwardRef as ReactComponent };